module.exports = __webpack_public_path__ + "static/img/105.9e60008.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/190912/105.jpg
// module id = i3Jt
// module chunks = 0